import React from "react";
import { Link } from "react-router-dom";
import useTitle from "../../hooks/useTitle";

const Error = () => {
  useTitle("Error")
  return <div className="bg-[#0E1629] py-36">
    <div className=" container">
      <div>
          <div className="text-center w-full md:w-1/2 mx-auto bg-[#182233] p-10 rounded-lg">
            <h1 className="text-7xl font-semibold text-[#22d3ee]">404</h1>
            <h2 className="text-3xl font-semibold my-3 text-white">OPPS! PAGE NOT FOUND</h2>
            <p className="text-white">Sorry, the page is not found. Please try again...</p>
            <Link to={'/'} className="bg-transparent text-white capitalize border-2 border-[#22d3ee] py-2 px-6 rounded-full mt-7 hover:bg-[#22d3ee] hover:text-white duration-500 inline-block">Go to Home page</Link>
          </div>
      </div>
    </div>
  </div>;
};

export default Error;
